import React from 'react';
import { FaDotCircle } from 'react-icons/fa';
const TravelDetails = () => {
  return (
    <div className="py-4 px-[8%]">
      <div className="w-full relative h-24 py-5 bg-slate-900 text-white text-center">
        <h1 className="text-4xl font-bold">Travel Agency Service</h1>
      </div>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 gap-5"
        data-aos="fade-down"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center w-full h-72 BoxFive">
          <div className="divFive div5"></div>
          <h1 className="text-3xl font-bold text-slate-900">Home Page</h1>
        </div>
        <div className="text-center w-full h-72 DashBoard5">
          <div className="dashFive dash5"></div>

          <h1 className="text-3xl font-bold text-slate-900">Details Page</h1>
        </div>
      </div>

      <div className=" text-center mt-32 mx-auto">
        <h1 className="text-3xl font-bold mb-7 ">
          Used Languages and Technologies
        </h1>
        <div className="usedTechnologies grid grid-cols-6 my-6 mx-auto w-[90%] text-center justify-center">
          <div className="w-10 h-10 rounded-full flex">
            <img
              src="https://static-00.iconduck.com/assets.00/next-js-icon-2048x2048-5dqjgeku.png"
              alt=""
              className="w-10 h-10"
            />
            <img
              src="https://static-00.iconduck.com/assets.00/nextjs-icon-512x309-yynfidez.png"
              alt=""
              className="w-10 h-10 ml-2"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://cdn-icons-png.freepik.com/512/919/919826.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4ev14ptwsgUY4H3TsmBfoJ3mVFAXzOPRIlQ&s"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full text-center justify-center">
            <img
              src="https://cdn.iconscout.com/icon/free/png-256/free-mongodb-3-1175138.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
        </div>
      </div>
      <div
        className="details"
        data-aos="fade-down"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center">
          <h1 className="text-2xl text-slate-900 font-bold">
            Travel Agency (
            <a
              className="text-blue-600"
              href="https://hafejia-travel-tours.vercel.app/"
            >
              Live Site
            </a>
            :{' '}
            <a
              className="text-blue-600"
              href="https://github.com/kutub98/Hafejia-travel-tours-final-"
            >
              Client Code
            </a>{' '}
            )
          </h1>
        </div>
        <div className="">
          <h1>
            It's based on Organic Medicine service. Here users can Buy or order
            from a here through the mail, Phone, and the owner will contact.
          </h1>
          <ul>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              It's based on online E-Commerce Organic Medicine. User can buy any
              kind of Organic Food.
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              User can see all review
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>User can give review
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Database Integration, Implementing Authentication & Authorization,
              secureToken using JWT
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TravelDetails;
